import BaseService from '_services/rest/base';

class EquipmentService extends BaseService {
  constructor() {
    super();
  }

  deleteEquipment(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/equipment`;
  }

  getUrlSave(id) {
    if (id) {
      return {
        url: `${this.getUrl()}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}`,
      method: 'POST',
    };
  }

  getList(params) {
    const filters = { search: params.search, type: params.type, all: params.all || false };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getEquipmentById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getCategories() {
    return this.request(`${this.getUrl()}/categories`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(equipment) {
    const meta = this.getUrlSave(equipment.id);
    return this.request(meta.url, equipment, meta.method)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  saveCategory(category) {
    const url = category.id
      ? `${this.getUrl()}/categories/${category.id}`
      : `${this.getUrl()}/categories`;
    const method = category.id ? 'PUT' : 'POST';

    return this.request(url, category, method)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  deleteCategory(id) {
    return this.request(`${this.getUrl()}/categories/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }
}

export default new EquipmentService();
